import { Home, MessageSquare, FileText, ChartAreaIcon, Shield, DollarSign, Bell, User, Settings, Facebook, Instagram, Music, Twitter } from "lucide-react";
import { BiAnalyse } from "react-icons/bi";
import React from "react";
import { Link } from "react-router-dom";

const MyProfileSidebarComponent = () => {
    const sidebarItems = [
        { icon: <Home className="h-5 w-5" />, label: "Dashboard", href: "/clients" },
        { icon: <MessageSquare className="h-5 w-5" />, label: "Messages", href: "/clients/messageandvideocall" },
        { icon: <FileText className="h-5 w-5" />, label: "My Orders", href: "/clients/myorders" },
        { icon: <ChartAreaIcon className="h-5 w-5" />, label: "Progress", href: "/clients/progress" },
        { icon: <Shield className="h-5 w-5" />, label: "Support Tickets", href: "/clients/support" },
        { icon: <DollarSign className="h-5 w-5" />, label: "Wallet", href: "/clients/Wallet" },
        { icon: <Bell className="h-5 w-5" />, label: "Notifications", href: "/clients/myoffers" },
        { icon: <User className="h-5 w-5" />, label: "Profile", href: "/clients/profile", active: true },
        { icon: <Settings className="h-5 w-5" />, label: "Settings", href: "/clients/profilesettings" },
        { icon: <BiAnalyse className="h-5 w-5" />, label: "Report", href: "/clients/reports" },
    ];

    return (
        <aside className="hidden lg:block fixed left-0 top-16 bottom-0 w-64 bg-white border-r shadow-sm overflow-y-auto">

            <nav className="p-4 space-y-1">
                <div className="flex-1 overflow-y-auto">
                    {sidebarItems.map((item, index) => (
                        <Link
                            key={index}
                            to={item.href}
                            className={`flex items-center gap-3 px-4 py-2 rounded-lg text-sm transition-colors ${item.active ? "text-blue-600 bg-blue-50 font-medium" : "text-gray-600 hover:bg-gray-50"
                                }`}
                        >
                            {item.icon}
                            <span>{item.label}</span>
                        </Link>
                    ))}
                </div>
            </nav>
        </aside>
    );
};

export default MyProfileSidebarComponent;